import React from "react";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { isLoggedIn, isUserAdmin } from "../../helpers";
import { ReducerState } from "../../helpers/reducers";
import { Navigator } from "../../lib/routing/Navigator";
import Header from "../../pages/Template/Header";
import { AppState } from "../../store";
import "./App.css";
import AppRehydrate from "./AppRehydrate";
import AppUser from "./AppUser";
import { configureRoutes } from "./routes";
import { usePageViews } from "./tracking";
import * as pages from "../../pages";
import * as admin from "../../admin";

const mapStateToProps = (state: AppState) => ({
    user: state.user,
    settings: state.settings,
});

type StateProps = {
    user: ReducerState;
    settings: ReducerState;
};

type Props = StateProps;

function App(props: Props) {
    usePageViews();
    const location = useLocation();
    const params = useParams();

    const isAuth = isLoggedIn(props.user);
    const isAdmin = isUserAdmin(props.user);

    return (
        <AppRehydrate>
            <AppUser>
                <Header location={location} />
                {configureRoutes({
                    list: admin,
                    isAuth,
                    isAdmin,
                    location,
                    match: {
                        params,
                    },
                })}

                {configureRoutes({
                    list: pages,
                    isAuth,
                    isAdmin,
                    location,
                    match: {
                        params,
                    },
                })}
                <Navigator />
            </AppUser>
        </AppRehydrate>
    );
}

export default connect(mapStateToProps)(App);
